import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { PageTitle } from "../../components/Layout";
import * as Icons from "lucide-react";

export default function CollabClients() {
  const [clients, setClients] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const nav = useNavigate();
  useEffect(() => { api.get("/collab/clients").then((r) => { setClients(r.data); setLoaded(true); }); }, []);

  return (
    <div>
      <PageTitle overline="Consultation" title="Entreprises" />
      {loaded && clients.length === 0 && (
        <p className="text-sm text-marine/80">Aucune fiche entreprise accessible. Contactez Metara si vous pensez qu'il s'agit d'une erreur.</p>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {clients.map((c) => (
          <button key={c.id} onClick={() => nav(`/clients/${c.id}`)} data-testid={`collab-client-${c.id}`}
            className="text-left bg-sable rounded-sm border border-marine/10 shadow-sm p-5 card-lift hover:border-marine/40 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-marine text-white flex items-center justify-center font-display text-xl">{c.name?.[0]}</div>
            <div>
              <div className="font-display text-lg text-marine">{c.name}</div>
              <div className="text-xs text-marine/80">{c.project_count} projet{c.project_count > 1 ? "s" : ""}</div>
            </div>
            <Icons.ChevronRight size={16} className="text-marine ml-auto" />
          </button>
        ))}
      </div>
    </div>
  );
}
